/** @module app.test */

import { Loader, autoinject, resolver } from 'aurelia-framework';
import { TestRunner } from 'app/test/runner';
import { TestResolver } from 'app/test/resolver';
import { ITest, ITestResult, ITestSession } from 'app/test/types';
import { TestContext } from 'app/test/context';

@autoinject
export class TestContainer {

    private modules: string[] = [];

    constructor(private readonly loader: Loader, private readonly resolver: TestResolver) { }

    public registerTests(...modules: string[]): this {
        this.modules.push(...modules);
        return this;
    }

    public async createRunner(context: TestContext = new TestContext()): Promise<TestRunner> {
        const tests: ITest[] = [];

        for(const modulesId of this.modules) {
            const module = await this.loader.loadModule(modulesId);

            tests.push(...await this.resolver.resolveTests(context, module));
        }

        return new TestRunner(...tests);
    }

    public async runAll(): Promise<ITestSession> {
        const context = new TestContext();
        const runner = await this.createRunner(context);
        await runner.run(context);
        return context;
    }

}
